import React from 'react';
import PropTypes from 'prop-types';
import { ProFormRadio, ProFormTextArea } from '@ant-design/pro-form';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { message } from 'antd';
import ProForm from 'components/layout/ProForm';
import { WIDTH_2_COL } from 'constants/form';
import {
  SUBMIT_REPORT_REVIEW,
  GET_REPORT_SUBMISSION_FORM_DETAIL,
  GET_REPORT_SUBMISSION,
} from 'gql/reportSubmissions';
import { GET_PENDING_APPROVALS } from 'gql/pendingApprovals';
import { GET_PROJECTS } from 'gql/projects';
import objMap from 'utils/objMap';
import useProjectFrozen from 'hooks/useProjectFrozen';

const convertValuesToSectionDetails = objMap((key, value) => ({
  question: key,
  answer: value,
}));

const ReportReviewForm = ({
  sequence,
  detail,
  isCurrent,
  isCurrentAppointedReviewer,
}) => {
  const { id, projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const [submitReportReview] = useMutation(SUBMIT_REPORT_REVIEW, {
    refetchQueries: [
      { query: GET_REPORT_SUBMISSION_FORM_DETAIL, variables: { ids: [id] } },
      { query: GET_REPORT_SUBMISSION, variables: { ids: [id] } },
      { query: GET_PROJECTS, variables: { ids: [projectId] } },
      {
        query: GET_PENDING_APPROVALS,
        variables: {
          ignoreNotAuthorised: true,
        },
        errorPolicy: 'all',
      },
    ],
    onCompleted: () => {
      message.success('Submitted successfully');
    },
    onError: (error) => {
      console.error(error);
    },
  });
  const disabled = !isCurrentAppointedReviewer || !isCurrent || projectFrozen;
  // const disabled = false;
  const onFinish = async (values) => {
    await submitReportReview({
      variables: {
        input: {
          id,
          projectId,
          sequence,
          sectionDetails: convertValuesToSectionDetails(values),
        },
      },
    });
  };

  return (
    <ProForm disabled={disabled} onFinish={onFinish}>
      {detail.map(
        ({ questionType, question, questionText, mandatory, options }) => {
          switch (questionType) {
            case 'TEXT':
              return (
                <ProFormTextArea
                  name={question}
                  label={questionText}
                  width={WIDTH_2_COL}
                  disabled={disabled}
                  key={question}
                  rules={
                    mandatory && [{ required: true, message: 'Please enter' }]
                  }
                />
              );
            case 'RADIO':
              return (
                <ProFormRadio.Group
                  name={question}
                  key={question}
                  label={questionText}
                  options={options}
                  disabled={disabled}
                  rules={
                    mandatory && [{ required: true, message: 'Please select!' }]
                  }
                />
              );
            default:
              return '';
          }
        }
      )}
    </ProForm>
  );
};

ReportReviewForm.propTypes = {
  sequence: PropTypes.number.isRequired,
  detail: PropTypes.array.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  isCurrentAppointedReviewer: PropTypes.bool.isRequired,
};

export default ReportReviewForm;
